module.exports = __webpack_public_path__ + "img/Wasin.34bbcadc.jpg";